import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FaBuildingWheat } from "react-icons/fa6";
import { FaHandHoldingHeart } from "react-icons/fa";
import { useState } from "react";
import { FaPrayingHands } from "react-icons/fa";


const BeniftContent = () => {
  const [activeTab, setActiveTab] = useState(0);
  // Function to handle tab change
  const handleTabChange = (index) => {
    setActiveTab(index);
  }

  return (
    <Tabs>
      <div className="lg:flex lg:flex-nowrap lg:space-x-10 benifit">
        <div className="lg:w-[43%]">
          {/* <!-- tabs --> */}

          <TabList className="nav nav-tabs mb-12 space-y-2">
            {audienceItems && audienceItems.map((item, index) => {
              return (
                <Tab key={item.title} className="nav-item">
                  <button
                    className="nav-link nav-link--style-2 group relative flex w-full border-b-one border-jacarta-100 p-6 text-left dark:border-jacarta-600"
                    type="button"
                    onClick={() => handleTabChange(index)}
                  >
                    <span className="text-accent mr-4 flex h-8 w-8 items-center justify-center text-2xl">
                      {item.icon}
                    </span>
                    <div>
                      <span className="mb-2 mt-1 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white transition transition-colors">
                        {item.title}
                      </span>
                      <div className="nav-link-content hidden">
                        <ul className="text-jacarta-500 dark:text-jacarta-300">
                          {item.content.map((text, index) => (
                            <li key={index}> 
                             {/* <span className="mt-1 text-accent float-left mr-1">
                              <svg
                                className="w-4 h-4"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                              </svg>
                            </span> */}
                              <span>{text}</span></li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </button>
                </Tab>
              );
            })}

          </TabList>
        </div>
        {/* End tablist */}

        <div className="flex items-center justify-center lg:w-[57%]">
          {/* <!-- content --> */}
          <div className="tab-content flex-1">
            <TabPanel>
              <div className=" relative">
                <figure className="flex items-center justify-center">
                  <img
                    src={audienceItems[activeTab]?.image}
                    alt="benifit"
                    className="rounded-full border border-jacarta-100 p-14 dark:border-jacarta-600"
                  />
                  <img
                    src="/images/dao/3d_elements_circle.png"
                    alt=""
                    className="absolute animate-spin-slow"
                  />
                </figure>
              </div>
            </TabPanel>

            <TabPanel>
              <div className="relative">
                <figure className="flex items-center justify-center">
                  <img
                    src={audienceItems[activeTab]?.image}
                    alt="benifit"
                    className="rounded-full border border-jacarta-100 p-14 dark:border-jacarta-600"
                  />
                  <img
                    src="/images/dao/3d_elements_circle.png"
                    alt="benifit"
                    className="absolute animate-spin-slow"
                  />
                </figure>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="relative">
                <figure className="flex items-center justify-center">
                  <img
                    src={audienceItems[activeTab]?.image}
                    alt="benifit"
                    className="rounded-full border border-jacarta-100 p-14 dark:border-jacarta-600"
                  />
                  <img
                    src="/images/dao/3d_elements_circle.png"
                    alt="benifit"
                    className="absolute animate-spin-slow"
                  />
                </figure>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="relative">
                <figure className="flex items-center justify-center">
                  <img
                   src={audienceItems[activeTab]?.image}
                    alt="benifit"
                    className="rounded-full border border-jacarta-100 p-14 dark:border-jacarta-600"
                  />
                  <img
                    src="/images/dao/3d_elements_circle.png"
                    alt="benifit"
                    className="absolute animate-spin-slow"
                  />
                </figure>
              </div>
            </TabPanel>
            <TabPanel>
              <div className=" relative">
                <figure className="flex items-center justify-center">
                  <img
                    src={audienceItems[activeTab]?.image}
                    alt="benifit"
                    className="rounded-full border border-jacarta-100 p-14 dark:border-jacarta-600"
                  />
                  <img
                    src="/images/dao/3d_elements_circle.png"
                    alt="benifit"
                    className="absolute animate-spin-slow"
                  />
                </figure>
              </div>
            </TabPanel>
          </div>
        </div>
      </div>
    </Tabs>
  );
};
const GraduationCapIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14c-4.418 0-8-2.686-8-6s3.582-6 8-6 8 2.686 8 6-3.582 6-8 6z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14v6m-4-2h8"></path>
  </svg>
);

const MegaphoneIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5.882V19.882a2 2 0 01-2 2H5a2 2 0 01-2-2V5.882a2 2 0 012-2h4a2 2 0 012 2z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 6.118L21 9v6l-4 2.882"></path>
  </svg>
);

const LightbulbGearsIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3L11.725 6m0 0a.75.75 0 001.05 0L15 3m-3 18v-2m-4-2H8m8 0h-1m-1.5-6a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 17a5 5 0 00-10 0v1a2 2 0 002 2h6a2 2 0 002-2v-1z"></path>
  </svg>
);

const FamilyIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4a4 4 0 100 8 4 4 0 000-8z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 20v-2a4 4 0 00-4-4H9a4 4 0 00-4 4v2"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10a2 2 0 100 4 2 2 0 000-4zM19 10a2 2 0 100 4 2 2 0 000-4z"></path>
  </svg>
);

const PaletteIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M12 16l3-3m2 2l4-4"></path>
  </svg>
);
const audienceItems = [
  {
    icon: <FaHandHoldingHeart />,
    title: "Campaigners & NGOs",
    content: [
      "Launch art-based fundraisers that deepen community involvement.",
      "Partner with artists or accept public contributions to diversify your content.",
      "Build a loyal supporter or membership base and reward them with access, recognition, or art.",
    ],
    image: "/images/new-one/art/campaigners_and_ngos.png",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-briefcase"
      >
        <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
    title: "Brands & Corporate Partners",
    content: [
      "Sponsor or co-create art campaigns that align with your purpose-driven values.",
      "Support artists and causes while building brand trust and visibility.",
      "Track engagement and impact.",
 ],
    image: "/images/new-one/art/brands_corporates_partners.png",
  },
  {
    icon: <FaPrayingHands />,
    title: "Collectors & Supporters",
    content: [
       "Collect art that supports real causes.",
      "See where your money goes and the impact it helps achieve.",
      "Submit art to active campaigns and earn from your contributions.",
      "Share and promote campaigns through the artwork you own or contribute.",
  ],
    image: "/images/new-one/art/collectors_and_supporters.png",
  },
  // {
  //   icon: <FamilyIcon />,
  //   title: "Parents & Families",
  //   content: [
  //     "Games that encourage emotional intelligence and positive values.",
  //     "Safe, inclusive, and engaging - great for screen time with meaning.",
  //     "Spark family conversations and actions through storytelling-based games.",
  //   ],
  //   image: "/images/new-one/parents_and_families.png",
  // },
  {
    icon: <FaBuildingWheat />,
    title: "Artists & Creatives",
    content: [
      "Contribute work to drive awareness and impact.",
      "Submit art to active campaigns and earn from your contributions.",
      "Use your creative voice to contribute directly to causes you care about.",
  ],
    image: "/images/new-one/art/artists_and_creatives.png",
  },
];
export default BeniftContent;
